import { render, staticRenderFns } from "./enrolled.vue?vue&type=template&id=6dcdf4a4&"
import script from "./enrolled.vue?vue&type=script&lang=js&"
export * from "./enrolled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dcdf4a4')) {
      api.createRecord('6dcdf4a4', component.options)
    } else {
      api.reload('6dcdf4a4', component.options)
    }
    module.hot.accept("./enrolled.vue?vue&type=template&id=6dcdf4a4&", function () {
      api.rerender('6dcdf4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/enrolled.vue"
export default component.exports